<template>
  <v-app>
    <v-content class="ground">
      <div v-if="isMobile">
        <ver-mobile></ver-mobile>
      </div>
      <div v-else>
        <v-card class="mx-auto my-12" :max-width="wpoint ? 350 : 280">
          <div
            style="height:150px; margin-left: auto; margin-right: auto; text-align: center; padding-top: 50px"
            class="mx-auto"
          >
            <img src="../assets/img/LogoMin.png" alt="" />
          </div>
          <v-card-text align="center">
            <div>Escreva nova palavra passe</div>
          </v-card-text>

          <v-card-text>
            <!--Form User-->
            <recover-password></recover-password>
          </v-card-text>

          <v-divider class="mx-4"></v-divider>
          <v-container>
            <!--Forget Session-->
            <options-form></options-form>
          </v-container>
          <v-card-text> </v-card-text>
        </v-card>
      </div>
      <!--        <alert-fail-login></alert-fail-login>-->
      <alert></alert>
    </v-content>
  </v-app>
</template>
<script>
import MobileView from "../components/mobile/MobileView";
import OptionForm from "../components/login/OptionForm";
import Alert from "../components/tools/Alert";
import RecoverPassword from "../components/login/RecoverPassword";
import jwtDecode from "jwt-decode";
import apiServices from "../../services/apiServices";
export default {
  name: "ResetPwd",
  components: {
    RecoverPassword,
    alert: Alert,
    "options-form": OptionForm,
    "ver-mobile": MobileView
  },
  data: () => ({
    wpoint: true,
    isMobile: false
  }),
  methods: {
    getParams() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("kyami");
    }
  },
  computed: {
    getView() {
      const wBreakpoint = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
      return wBreakpoint;
    }
  },
  mounted() {
    const isMob = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMob) {
      return (this.isMobile = true);
    }
    if (this.getView < 350) {
      return (this.wpoint = false);
    } else {
      return (this.wpoint = true);
    }
  },
  created() {
    if (!this.getParams()) this.$router.push("/NotFound");
    const decode = jwtDecode(this.getParams());
    if (decode.exp < new Date().getTime() / 1000) return this.$router.push("/");
    apiServices.customizeHeader(this.getParams());
  }
};
</script>

<style scoped>
/*.ground{*/
/*    background-color: #deebff1f;*/
/*}*/
.ground {
  /*//background-color: #deebff1f;*/
  background: url(../assets/img/cubic.svg), linear-gradient(#1173d3, #480600),
    repeat;
  /*rgba(0, 153, 255, 1)*/
  /*  #630902f0*/
  /*rgb(255 141 0)*/
}
</style>
